import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  FaMapMarked,
  FaBed,
  FaShareAlt,
  FaRegBookmark,
  FaBookmark,
  FaMapMarker,
  FaCameraRetro
} from "react-icons/fa";
import { GoHome } from "react-icons/go";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { IoDocumentTextOutline } from "react-icons/io5";
import { LuUserSquare2 } from "react-icons/lu";
import {
  MdOutlineCalendarMonth,
  MdOutlinePhone,
  MdNoteAlt,
} from "react-icons/md";
import { RxDimensions } from "react-icons/rx";
import { TbLamp } from "react-icons/tb";
import Cookies from "js-cookie"; // Import js-cookie if not already imported
import Dropdown from "./CustomDropdown";
import {
  RENT_STATUS_OPTIONS,
  SELL_STATUS_OPTIONS,
} from "../constants/PropertyFieldDropdowns";
import { toast } from "react-toastify";
import PropertyCard from "./PropertyCard"; // Ensure this import is present
import './List.css'; // Import the CSS file for styling
import Photos_Video from "./Photos_Video";
import ShareModal from "./ShareModal";

import {
  Building2,
  Share2,
  Phone,
  Search,
  Filter,
  Heart,
  Eye,
  Building,
  MapPin,
  Square,
  Pin,
  ChevronRight,
  GripVertical,
  Calendar,
  LayoutGrid,

  ChevronLeft,
  ChevronDown,
  Maximize2,
  Minimize2
} from 'lucide-react';
import apiClient from "../common/apiClient";
import { useLocation } from "react-router-dom";





function List({ properties, fetchProperties, property, onSaveStatusChange, requirement }) {
  const location = useLocation(); // ✅ place hook here
  const pathname = location.pathname;

  // ✅ define your path-based flags FIRST
  const isRequirementPath =
    pathname.includes("residential-rental/requirement") ||
    requirement === true ||
    properties.some((prop) => prop.propertyType === "requirement");

  const isSpecialPath =
    pathname.includes("residential-rental/broker") ||
    pathname.includes("residential-rental/builder") ||
    properties.some((prop) => prop.propertyType === "broker");

  const [pinnedColumns, setPinnedColumns] = useState([]);
  const [contactInfoMap, setContactInfoMap] = useState({});
  const [loadingMap, setLoadingMap] = useState({});
  const [savedPropertiesMap, setSavedPropertiesMap] = useState({});
  const [editingMap, setEditingMap] = useState({});
  const [remarksMap, setRemarksMap] = useState({});
  const [propertyTypes, setPropertyTypes] = useState([]); // State for property types
  const [statusMap, setStatusMap] = useState({});
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSaved, setIsSaved] = useState(property?.isSaved || false);
  const [showDescMap, setShowDescMap] = useState({});
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [currentShareText, setCurrentShareText] = useState("");
  const [status, setStatus] = useState(
    isSpecialPath
      ? property?.propertyCurrentStatus || "available"
      : property?.status || "Not Answer"
  );
  const [previousStatus, setPreviousStatus] = useState(
    isSpecialPath
      ? property?.propertyCurrentStatus || "available"
      : property?.status || "Not Answer"
  );

  const brokerName = Cookies.get("name");
  const brokerNumber = Cookies.get("number");
  const companyName = Cookies.get("companyName");


 const getWhatsAppMessage = (property) => {
  const propertyName = property?.title || "Property";
  const type = property?.type || ""; 
  // examples: "Residential Rent", "Residential Sell", "Commercial Rent", "Commercial Sell"

  const isResidential = type.toLowerCase().includes("residential");
  const isCommercial = type.toLowerCase().includes("commercial");
  const isRent = type.toLowerCase().includes("rent");

  const action = isRent ? "Rent" : "Sale";

  const bhk = property?.bhk || "";
  const subType = property?.unitType || property?.subType || "";

  let firstLine = `Hello, is your ${propertyName} property available for ${action}?`;

  if (isResidential) {
    // Residential → add BHK + subtype
    // Example: Hello, is your Green Villa 2 BHK Flat property available for Rent?
    firstLine = `Hello, is your  ${bhk ? bhk : " "} ${subType} in ${propertyName} property available for ${action}?`;
  }

  if (isCommercial) {
    // Commercial → add only subtype
    // Example: Hello, is your Star Hub Office property available for Sale?
    firstLine = `Hello, is your  ${subType} in ${propertyName} property available for ${action}?`;
  }

  return `${firstLine}

Name: ${brokerName}
Number: ${brokerNumber}
Company: ${companyName}`;
};



  // Add status options based on path type. Rent listings close as "Rent out",
  // sell listings as "Sell out" — same rule CustomDropdown uses for the cards.
  const getStatusOptions = (propertyType) => {
    if (isRequirementPath) {
      return ["Active", "Fulfilled", "Cancelled"];
    } else if (isSpecialPath) {
      return ["Available", "Rented", "Sold", "Fake Listing"];
    } else {
      return String(propertyType || "").toLowerCase().includes("rent")
        ? RENT_STATUS_OPTIONS
        : SELL_STATUS_OPTIONS;
    }
  };

  // Add this function after your other state handlers
  const toggleDescription = (propertyId) => {
    setShowDescMap(prev => ({
      ...prev,
      [propertyId]: !prev[propertyId]
    }));
  };

  // Check if the new status is one of the specified statuses

  //  if (isSpecialPath) {
  //       return ["available", "rented", "sold"];
  //     }
  // Initialize remarks from properties
  useEffect(() => {
    const initialRemarks = {};
    properties.forEach(property => {
      initialRemarks[property._id] = property.remark || "";
    });
    setRemarksMap(initialRemarks);
  }, [properties]);

  useEffect(() => {
    const fetchPropertyTypes = async () => {
      try {

        // Fetch the property counts when the component mounts
        const response = await apiClient(
          "get",
          "/cjidnvij/ceksfbuebijn/property/types"
        );

        if (response.success) {
          //console.log("✅ Decrypted Response:", response.data);
        } else {
          // console.error("❌ Error:", response.error);
        }

        // const response = await axios.get(`${process.env.REACT_APP_API_IP}/cjidnvij/ceksfbuebijn/property/types`);
        setPropertyTypes(response.data.types);
      } catch (error) {
        // console.error("Error fetching property types:", error);
        // Fallback to predefined types if fetching fails
        setPropertyTypes(["All", "Residential Rent", "Commercial Rent", "Residential Sell", "Commercial Sell"]);
      }
    };

    fetchPropertyTypes();
  }, []);



  const handleSaveRemark = async (propertyId) => {
    try {
      const payload = {
        userId: userId,
        propId: propertyId,
        remark: remarksMap[propertyId],
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_IP}/cjidnvij/ceksfbuebijn/user/jcebduvhd/vehbvyubheud/property-remark`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update remark.");
      }

      const result = await response.json();

      if (result.success) {
        toast.success("Remark updated successfully!");
        // Exit edit mode for this specific property
        setEditingMap(prev => ({
          ...prev,
          [propertyId]: false
        }));
      } else {
        toast.error(result.message || "Failed to update remark. Please try again.");
      }
    } catch (error) {
      // console.error("Error saving remark:", error);
      toast.error(error.message || "An error occurred while saving the remark.");
    }
  };


  // in premises name click and redirect on googole map 

  function openInGoogleMaps(address) {
    if (!address) return;

    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(mapsUrl, '_blank', 'noopener,noreferrer');
  }

  const handleCancelEdit = (propertyId) => {
    // Exit edit mode for this specific property
    setEditingMap(prev => ({
      ...prev,
      [propertyId]: false
    }));
    // Reset remark to original value for this property
    setRemarksMap(prev => ({
      ...prev,
      [propertyId]: properties.find(p => p.id === propertyId)?.remark || ""
    }));
  };



  // Initialize saved states from properties
  useEffect(() => {
    const initialSavedStates = {};
    properties.forEach(property => {
      initialSavedStates[property._id] = property.isSaved || false;
    });
    setSavedPropertiesMap(initialSavedStates);
  }, [properties]);

  // Initialize status map from properties
  useEffect(() => {
    const initialStatuses = {};
    properties.forEach(property => {
      initialStatuses[property._id] = property.status || "Active";
    });
    setStatusMap(initialStatuses);
  }, [properties]);

  // Move these utility functions outside of handleGetContact
  const copyToClipboard = (text) => {
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
  };

  const userId = Cookies.get("userId");
  // Import useLocation from react-router-dom if not already imported
  // const { pathname } = window.location;
  // // Check if we're on the requirements path or have requirement properties
  // const isRequirementPath = pathname.includes("residential-rental/requirement") || 
  //                          requirement === true || 
  //                          properties.some(prop => prop.propertyType === "requirement");
  // // Check if we're on the special path or have broker properties
  // const isSpecialPath = pathname.includes("residential-rental/broker") || 
  //                       pathname.includes("residential-rental/builder") ||
  //                       properties.some(prop => prop.propertyType === "broker");

  // Save and UnSave
  const handleSaveClick = async (propertyId) => {
    try {
      // Check if we have the required data
      if (!userId) {
        toast.error("User ID is missing. Please login again.");
        return;
      }
      if (!propertyId) {
        toast.error("Property ID is missing.");
        return;
      }

      let response;

      // Check if we're on the requirements path
      if (isRequirementPath) {
        // Use the saveRequirements endpoint for requirements
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/saveRequirements",
          {
            userId: userId,
            requirementId: propertyId,
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`
            }
          }
        );
      } else if (isSpecialPath) {
        // Use the saveProperties endpoint for special path
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/saveProperties",
          {
            userId: userId,
            propertyId: propertyId,
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`
            }
          }
        );
      } else {
        // Use the regular save-property endpoint for properties
        response = await apiClient(
          "post",
          `/cjidnvij/ceksfbuebijn/user/save-property/ijddskjidns/cudhsbcuev`,
          {
            userId: userId,
            propId: propertyId,
          }
        );
      }

      if (response.data.success) {
        const isSaved = response.data.data.saved;
        // Update the saved state for this specific property
        setSavedPropertiesMap(prev => ({
          ...prev,
          [propertyId]: isSaved
        }));

        toast.success(isSaved ?
          (isRequirementPath ? "Requirement saved successfully" : "Property saved successfully") :
          (isRequirementPath ? "Requirement unsaved successfully" : "Property unsaved successfully")
        );

        if (typeof onSaveStatusChange === 'function') {
          onSaveStatusChange(propertyId, isSaved);
        }
      } else {
        // console.error("Save property failed:", response.data);
        toast.error(response.data.error || "Failed to update save status");
      }
    } catch (error) {
      // console.error("Error saving property:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "Failed to update save status. Please try again.");
    }
  };

  const formatPrice = (price) => {
    if (!price || price === 0 || price === "0") return "₹0";

    // Convert to string for uniform handling
    const str = String(price).toLowerCase().trim();

    // Handle string-based inputs like "41 lacs" or "2.5 cr"
    if (str.includes("lac")) {
      const value = parseFloat(str);
      return `₹${value}${value % 1 === 0 ? "" : ""}Lac`;
    }
    if (str.includes("cr")) {
      const value = parseFloat(str);
      return `₹${value}${value % 1 === 0 ? "" : ""}Cr`;
    }

    // If numeric
    const num = Number(str.replace(/[^0-9.]/g, ""));
    if (isNaN(num)) return "NA";

    if (num >= 10000000) {
      const crValue = num / 10000000;
      return `₹${crValue % 1 === 0 ? Math.floor(crValue) : crValue.toFixed(2)
        }Cr`;
    }
    if (num >= 100000) {
      const lacValue = num / 100000;
      return `₹${lacValue % 1 === 0 ? Math.floor(lacValue) : lacValue.toFixed(2)
        }Lac`;
    }

    return `₹${num.toLocaleString("en-IN")}`;
  };

  const formatPriceRange = (priceRange) => {
    if (!priceRange) return "NA";

    const min = priceRange.min;
    const max = priceRange.max;

    // No values
    if (!min && !max) return "NA";

    // Only min
    if (min && !max) return formatPrice(min);

    // Only max
    if (!min && max) return formatPrice(max);

    // Both same
    if (min === max) return formatPrice(min);

    // Both exist
    return `${formatPrice(min)} - ${formatPrice(max)}`;
  };
  const showToast = (message) => {
    const toast = document.createElement("div");
    toast.innerText = message;
    toast.style.position = "fixed";
    toast.style.bottom = "20px";
    toast.style.left = "50%";
    toast.style.transform = "translateX(-50%)";
    toast.style.backgroundColor = "#333";
    toast.style.color = "#fff";
    toast.style.padding = "10px 20px";
    toast.style.borderRadius = "5px";
    toast.style.zIndex = "1000";
    document.body.appendChild(toast);

    setTimeout(() => {
      document.body.removeChild(toast);
    }, 3000);
  };

  // Move handleShareClick outside of handleGetContact
  const handleShareClick = (property) => {
    const brokerName = Cookies.get("name");
    const brokerNumber = Cookies.get("number");


    // Create the share message
    const shareText = `
**${property?.type === "Residential Rent" || property?.type === "Residential Sell"
        ? `${property?.bhk || ""}${property?.bhk ? " " : ""}${property?.unitType || ""} Available for ${property?.type === "Residential Rent" ? "Rent" : "Sale"}`
        : property?.type === "Commercial Rent" || property?.type === "Commercial Sell"
          ? `${property?.unitType || ""} Available for ${property?.type === "Commercial Rent" ? "Rent" : "Sale"}`
          : "Property Available"
      }**

⦁ Premise: ${property?.title || "NA"}

⦁ Address: ${property?.area || "NA"}, ${property?.city || "NA"}

${isRequirementPath ? (
        property?.sizeRange?.sqFt ?
          `⦁ Square Ft: ${property.sizeRange.sqFt.min || 0}-${property.sizeRange.sqFt.max || 0} SqFt` :
          "⦁ Square Ft: N/A"
      ) : (
        `⦁ Square Ft: ${property?.sqFt || "NA"} SqFt`
      )}

⦁ Furnished Type: ${property?.furnishedType || "NA"}

${isRequirementPath ? (
        property?.priceRange ?
          `⦁ Price: ${formatPriceRange(property.priceRange)}` :
          "⦁ Price: N/A"
      ) : (
        property?.type === "Residential Rent" || property?.type === "Commercial Rent" ?
          `⦁ Rent: ${isSpecialPath ? "Rs. " + formatPrice(property?.price) : "Rs. " + formatPrice(property?.rentValue)}` :
          `⦁ Price: ${isSpecialPath ? "Rs. " + formatPrice(property?.price) : "Rs. " + formatPrice(property?.rentValue)}`
      )}

⦁ PID: ${isRequirementPath ? property.requirementId : property.propertyId}

**Name: ${brokerName || "NA"}**
**Number: ${brokerNumber || "NA"}**
`.trim();

    setCurrentShareText(shareText);
    setIsShareModalOpen(true);
  };

  const handleGetContact = async (propertyId) => {
    // Check if contact info is already showing for this property
    if (contactInfoMap[propertyId]) {
      // If already showing, hide it (toggle functionality)
      setContactInfoMap(prev => {
        const newMap = { ...prev };
        delete newMap[propertyId];
        return newMap;
      });
      return;
    }

    setLoadingMap(prev => ({ ...prev, [propertyId]: true }));

    try {
      let response;

      if (isRequirementPath) {
        // Call broker-requirements/contact API for requirements
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/broker-requirements/contact",
          {
            userId: Cookies.get("userId"),
            requirementId: propertyId
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get('token')}`
            }
          }
        );
      } else if (isSpecialPath) {
        // Call broker-properties/contact API for broker/builder properties
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/broker-properties/contact",
          {
            userId: Cookies.get("userId"),
            propId: propertyId,
            listedBy: location.pathname.includes("broker") ? "broker" : "builders"
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get('token')}`
            }
          }
        );
      } else {
        // Call regular contact API for normal properties
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/v2/contacted/kcndjiwnjn/jdnjsnja/cxlbijbijsb",
          {
            userId: Cookies.get("userId"),
            propId: propertyId,
          }
        );
      }
   // ✅ Handle API Error (e.g. 429 Too Many Requests)
      if (!response.success) {
        if (response.status === 429) {
          const { blockedUntil, message } = response.error || {};

          if (blockedUntil) {
            const retryAfterMs = new Date(blockedUntil).getTime() - Date.now();
            const retryAfterSec = Math.ceil(retryAfterMs / 1000);

            toast.error(`Too many requests. Retry after ${retryAfterSec} seconds.`);
          } else {
            toast.error(message || "Too many requests. Please try again later.");
          }
          return;
        }

        // setContactError(
        //   response.error?.message ||
        //   (typeof response.error === "string" ? response.error : "Failed to fetch contact info")
        // );
        // return;
      }
      if (response.data && response.data.success) {
        const contactData = response.data.data;

        // Map brokerName to name and contactNumber to number if needed
        const mappedContactData = {
          name: contactData.name || contactData.brokerName || "",
          number: contactData.number || contactData.contactNumber || ""
        };

        if (mappedContactData.name || mappedContactData.number) {
          // Clear all previous contact info and set only the current one
          setContactInfoMap({
            [propertyId]: mappedContactData
          });

          // Auto-dial on mobile devices
          const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);
          if (isMobileDevice && mappedContactData.number) {
            let phoneNumber = mappedContactData.number;
            if (phoneNumber.startsWith("+91")) {
              phoneNumber = phoneNumber.replace("+91", "").trim();
            }
            window.location.href = `tel:${phoneNumber}`;
          }
        } else {
          toast.error("Contact information not available");
        }
      } else {
        toast.error(response.data?.error || "Failed to retrieve contact information");
      }
    } catch (error) {
      console.error("Error fetching contact info:", error);
      toast.error(error.response?.data?.message || "Error retrieving contact information");
    } finally {
      setLoadingMap(prev => ({ ...prev, [propertyId]: false }));
    }
  };

  const toggleColumnPin = (column) => {
    setPinnedColumns(prev => {
      if (prev.includes(column)) {
        return prev.filter(col => col !== column);
      } else {
        return [...prev, column];
      }
    });
  };


  const getFurnishingColor = (furnishedType) => {
    if (!furnishedType || typeof furnishedType !== 'string') {
      return 'bg-gradient-to-r from-slate-500/10 to-gray-500/10 text-slate-700 border-slate-200';
    }
    switch (furnishedType.toLowerCase()) {
      case 'furnished':
        return "bg-gradient-to-r from-sky-500/10 to-blue-500/10 text-sky-700 border-sky-200";
      case 'semi-furnished':
        return 'bg-gradient-to-r from-amber-500/10 to-yellow-500/10 text-amber-700 border-amber-200';
      default:
        return 'bg-gradient-to-r from-slate-500/10 to-gray-500/10 text-slate-700 border-slate-200';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Active":
        return "bg-gradient-to-r from-green-500/10 to-emerald-500/10 text-green-700 border-green-200";
      case "Rent out":
        return "bg-gradient-to-r from-orange-500/10 to-amber-500/10 text-orange-700 border-orange-200";
      case "Sell out":
      case "Sell Out":
        return "bg-gradient-to-r from-orange-500/10 to-amber-500/10 text-orange-700 border-orange-200";
      case "Data Mismatch":
        return "bg-gradient-to-r from-slate-500/10 to-gray-500/10 text-slate-700 border-slate-200";
      case "Not Answer":
        return "bg-gradient-to-r from-orange-500/10 to-amber-500/10 text-orange-700 border-orange-200";
      case "Broker":
        return "bg-gradient-to-r from-sky-500/10 to-blue-500/10 text-sky-700 border-sky-200";
      case "Duplicate":
        return "bg-gradient-to-r from-sky-500/10 to-blue-500/10 text-sky-700 border-sky-200"; // New color for Duplicate status
      default:
        return "";
    }
  };

  const calculateDaysDifference = (dateString) => {
    if (!dateString) return 0;
    const listedDate = new Date(dateString);
    const currentDate = new Date();
    const diffTime = currentDate - listedDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };
  function formatDate(dateString, propertyType) {
    if (!dateString) return "NA";

    const daysDiff = calculateDaysDifference(dateString);

    // Check for All propertyType - show "30 Days+" if >= 30 days old
    if ((propertyType === "Commercial Rent" || propertyType === "Commercial Sell" || propertyType === "Residential Sell" || propertyType === "Residential Rent") && daysDiff >= 30) {
      return "30 Days+";
    }

    // Check for Residential Sell or Commercial Sell - show "90 Days+" if >= 90 days old
    // if ((propertyType === "Residential Sell" || propertyType === "Commercial Sell") && daysDiff >= 90) {
    //   return "90 Days+";
    // }

    // Otherwise, show regular formatted date
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }// Accept properties as a prop

  // Handle status change
  const handleStatusChange = async (propertyId, newStatus) => {
    try {
      const path = location.pathname;
      const property = properties.find(p => p._id === propertyId);

      if (!property) {
        toast.error("Property not found");
        return;
      }

      const isBrokerOrBuilder =
        path.includes("residential-rental/broker") ||
        path.includes("residential-rental/builder");

      const isRequirementPath = path.includes("residential-rental/requirement");

      let response;

      if (isBrokerOrBuilder) {
        response = await apiClient(
          "put",
          `/cjidnvij/ceksfbuebijn/user/brokerproperties/${propertyId}/status`,
          { status: newStatus },
          { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
        );
      } else if (isRequirementPath) {
        response = await apiClient(
          "put",
          `/cjidnvij/ceksfbuebijn/user/brokerrequirements/${propertyId}/status`,
          { status: newStatus },
          { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
        );
      } else {
        const data = {
          propId: propertyId,
          userId: userId,
          newStatus: newStatus,
          previousStatus: statusMap[propertyId] || "Active",
          statusField: "status",
        };

        response = await apiClient(
          "post",
          `/cjidnvij/ceksfbuebijn/user/ckbwubuw/cjiwbucb/${propertyId}/status/cajbyqwvfydgqv`,
          data
        );
      }

      if (response?.data?.success) {
        // Update the status in the statusMap
        setStatusMap(prev => ({
          ...prev,
          [propertyId]: newStatus
        }));

        toast.success("Status updated successfully");
        if (typeof fetchProperties === "function") {
          setTimeout(fetchProperties, 100);
        }
      } else {
        toast.error(response?.data?.message || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(error?.response?.data?.message || error.message || "Failed to update status");
    }
  };

  // Screenshot protection effect
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Block PrintScreen key (try multiple key codes)
      if (e.key === "PrintScreen" || e.code === "PrintScreen" || e.keyCode === 44) {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        // Clear clipboard
        navigator.clipboard.writeText("").catch(() => {});
        return false;
      }
      // Block Ctrl+Shift+S (Windows screenshot tool)
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        return false;
      }
      // Block Ctrl+Shift+4/5 (Mac screenshot shortcuts)
      if (e.ctrlKey && e.shiftKey && (e.key === "4" || e.key === "5")) {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        return false;
      }
      // Block Windows+Shift+S
      if (e.metaKey && e.shiftKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        return false;
      }
      // Block Cmd+Shift+3/4/5 (Mac screenshot)
      if ((e.metaKey || e.key === "Command") && e.shiftKey && ["3", "4", "5"].includes(e.key)) {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        return false;
      }
    };

    const handleKeyUp = (e) => {
      // Also check on keyup for PrintScreen (some browsers fire it here)
      if (e.key === "PrintScreen" || e.code === "PrintScreen" || e.keyCode === 44) {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        // Attempt to clear clipboard
        navigator.clipboard.writeText("").catch(() => {});
        return false;
      }
    };

    // Prevent copy/paste/cut
    const preventCopy = (e) => {
      e.preventDefault();
      toast.error("Copying is not allowed");
      return false;
    };

    // Prevent drag and drop
    const preventDrag = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners to document
    document.addEventListener("keydown", handleKeyDown, true);
    document.addEventListener("keyup", handleKeyUp, true);
    document.addEventListener("copy", preventCopy, true);
    document.addEventListener("cut", preventCopy, true);
    document.addEventListener("dragstart", preventDrag, true);
    document.addEventListener("drop", preventDrag, true);

    // Disable right-click on entire document
    const preventContextMenu = (e) => {
      e.preventDefault();
      return false;
    };
    document.addEventListener("contextmenu", preventContextMenu, true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
      document.removeEventListener("keyup", handleKeyUp, true);
      document.removeEventListener("copy", preventCopy, true);
      document.removeEventListener("cut", preventCopy, true);
      document.removeEventListener("dragstart", preventDrag, true);
      document.removeEventListener("drop", preventDrag, true);
      document.removeEventListener("contextmenu", preventContextMenu, true);
    };
  }, []);

  return (
    <div 
      className="h-[calc(89vh-80px)] relative"
      onCopy={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div 
        className="bg-white rounded-2xl shadow-lg border border-slate-200/50 h-full flex flex-col select-none"
        style={{
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          userSelect: "none",
        }}
      >
        <div className="overflow-auto  flex-1">
          <table className="w-full bg-white  border-collapse">
            <thead className="sticky top-0 bg-slate-800 z-[999] ">
              <tr className="[&>*]:border-b-2 [&>*]:border-slate-200 h-[10px]">
                <th className="px-1 py-0.5 text-center min-w-[100px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-1 bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">PID</span>
                </th>
                <th className="px-1 py-0.5 text-center min-w-[100px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-1 bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Date</span>
                </th>
                <th className="px-1 py-0.5 text-center min-w-[80px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Type</span>
                </th>
                <th className="px-1 py-0.5 text-center min-w-[180px] relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold text-white">Premise Name</span>
                </th>

                <th className="px-1 py-0.5 text-center min-w-[120px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Subtype</span>
                </th>
                <th className="px-1 py-0.5 text-center min-w-[150px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Area</span>
                </th>
                <th className="px-1 py-0.5 text-center min-w-[100px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <div className="flex items-center justify-center gap-1">
                    <span className="font-sans font-bold  text-white">Sqft</span>
                  </div>
                </th>
                <th className="px-1 py-0.5 text-center min-w-[120px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Price</span>
                </th>

                <th className="px-1 py-0.5 text-center min-w-[140px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Furnishing</span>
                </th>
                <th className="px-1 py-0.5 text-center min-w-[100px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px py- bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Status</span>
                </th>
                {!isRequirementPath && (
                  <th className="px-1 py-0.5 text-center min-w-[480px] bg-slate-50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                    <span className="font-sans font-bold text-white">Address</span>
                  </th>
                )}

                <th className="px-1 py-0.5 text-center min-w-[490px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Description</span>
                </th>
                <th className={`${pinnedColumns.includes('contact') ? 'sticky right-0 ' : ''} px-2 py-0.5 text-center min-w-[180px] bg-slate-50/95 backdrop-blur-sm relative`}>
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <div className="flex gap-3 ">
                    <span className="font-sans font-bold  text-white">Contact Owner</span>
                    <button
                      onClick={() => toggleColumnPin('contact')}
                      className={`p-1 rounded-full hover:bg-slate-200/50 ${pinnedColumns.includes('contact') ? 'text-white' : 'text-slate-400'}`}
                    >
                      <Pin className="w-4 h-4" />
                    </button>
                  </div>
                </th>
                <th className="px-1 py-0.5 text-center min-w-[120px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Daily Contact</span>
                </th>
                <th className={`${pinnedColumns.includes('actions') ? 'sticky right-0 ' : ''}px-1 flex text-center min-w-[132px] bg-slate-100/95 backdrop-blur-sm relative`}>
                  <div className="absolute flex left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold pl-2 text-white">Actions</span>
                  <button
                    onClick={() => toggleColumnPin('actions')}
                    className={`pr-2 rounded-full hover:bg-slate-200/50 ${pinnedColumns.includes('actions') ? 'text-white' : 'text-slate-400'}`}
                  >
                    <Pin className="w-4 h-4" />
                  </button>
                </th>
                <th className="px-1 py-0.5 text-left min-w-[400px] bg-slate-50 relative">
                  <div className="absolute left-0 inset-y-0 w-px bg-slate-200/50"></div>
                  <span className="font-sans font-bold  text-white">Remarks</span>
                </th>
              </tr>
            </thead>

            <tbody className=" ">
              {properties.map((property, index) => (
                <tr
                  key={index}
                  className={`
                      hover:bg-slate-50/50 backdrop-blur-sm group relative
                      ${index % 2 === 0 ? 'bg-slate-50/10' : 'bg-white'}
                      border-l-4  hover:border-l-blue-400 transition-colors duration-200
                    `}
                >
                  <td className="px-3 py-2.5 text-[14px] text-slate-600 whitespace-nowrap hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-1 bg-slate-100/50 hover:bg-slate-200/50 transition-colors"></div>

                    <div className="flex font-sans font-semibold items-center gap-2">
                      {/* Isolated group for tooltip */}
                      <div className="relative group/tooltip">
                        <div
                          className={`
          w-3 h-3 rounded-full 
          ${property.verifyStatus === "unverified" ? "bg-yellow-400" : "bg-green-500"}
        `}
                        />
                        <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 w-max px-3 py-1 rounded bg-gray-800 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 whitespace-nowrap shadow-md">
                          {property.verifyStatus === "unverified" ? "This property is unverified" : "This property is verified"}
                        </div>
                      </div>

                      <span>{isRequirementPath ? property.requirementId : property.propertyId}</span>
                    </div>
                  </td>

                  <td className="px-3 py-2.5 text-[14px] text-slate-600 whitespace-nowrap group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-1 bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    <div className="flex font-sans font-semibold items-center gap-1">
                      {formatDate(property.listedDate, property.type)}
                    </div>
                  </td>
                  <td className="px-3 py-2.5 whitespace-nowrap group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    <span className={`inline-flex items-center px-2 py-[5px] rounded-2xl text-[14px] font-m border    font-sans font-semibold  bg-gradient-to-r from-blue-500/10 to-blue-500/10 text-blue-700 border-rose-200';`}>
                      {property.type}
                    </span>
                  </td>

                  <td className="px-3 py-2.5 group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    <span
                      className="font-sans text-[14px] font-semibold text-slate-800 cursor-pointer"
                      onClick={() =>
                        openInGoogleMaps(`${property?.title || ''} ${property?.area || ''}`)
                      }
                    >
                      {property.title || "N/A"}
                    </span>
                  </td>

                  <td className="px-3 py-1 text-center group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    {isRequirementPath ? (
                      <span className="font-sans text-[14px] font-semibold text-slate-700">{property.subtype || "N/A"}</span>
                    ) : property.type === "Commercial Rent" || property.type === "Commercial Sell" ? (
                      <span className="font-sans text-[14px] font-semibold text-slate-700">{property.unitType}</span>
                    ) : (
                      <div className="flex flex-col">
                        <span className="font-sans text-[14px] font-semibold text-slate-700">{property.bhk}</span>
                        <span className="font-sans text-[14px] font-semibold text-slate-700">{property.unitType}</span>
                      </div>
                    )}
                  </td>
                  <td className="px-3 py-2.5 group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    <div className="flex items-center font-sans font-semibold gap-1 text-[14px] text-slate-700">
                      <MapPin className="w-3 h-3 text-slate-400" />
                      {isRequirementPath ? (
                        property.areas && property.areas.length > 0 ?
                          property.areas.slice(0, 2).join(", ") + (property.areas.length > 2 ? "..." : "") :
                          "N/A"
                      ) : (
                        property.area
                      )}
                    </div>
                  </td>

                  <td className="px-3 py-2.5 text-center whitespace-nowrap group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    {isRequirementPath ? (
                      <span className="font-sans text-[14px] font-semibold text-slate-700">
                        {property.sizeRange?.sqFt ?
                          `${property.sizeRange.sqFt.min || 0}-${property.sizeRange.sqFt.max || 0} sqft` :
                          "N/A"}
                      </span>
                    ) : (
                      <span className="font-sans text-[14px] font-semibold text-slate-700">{property.sqFt} sqft</span>
                    )}
                  </td>

                  <td className="px-3 py-2.5 text-[14px] font-bold text-blue-500 text-center whitespace-nowrap group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors font-sans font-semibold"></div>


                    {isRequirementPath ? (
                      property.priceRange ?
                        (` ${formatPriceRange(property.priceRange)}`) :
                        "N/A"
                    ) : isSpecialPath ? (
                      "Rs. " + formatPrice(property.price)
                    ) : (
                      "Rs. " + formatPrice(property.rentValue)
                    )}
                  </td>

                  <td className="px-3 py-2.5 text-center whitespace-nowrap group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    {isRequirementPath ? (
                      <span className={`items-center font-sans font-semibold px-10 py-1.5 rounded-2xl text-[14px] border ${getFurnishingColor(property.furnishingPreferences ? property.furnishingPreferences.join(", ") : "")}`}>
                        {property.furnishingPreferences && property.furnishingPreferences.length > 0 ?
                          property.furnishingPreferences.map(pref => pref.replace("_", " ")).join(", ") :
                          "Any"}
                      </span>
                    ) : (
                      <span className={`items-center font-sans font-semibold px-10 py-1.5 rounded-2xl text-[14px] border ${getFurnishingColor(property.furnishedType)}`}>
                        {property.furnishedType}
                      </span>
                    )}
                  </td>
                  <td className="px-3 py-2.5 whitespace-nowrap group-hover:bg-white/50 relative">
                    <div className="absolute font-sans font-semibold left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    <select
                      value={statusMap[property._id] || "Active"}
                      onChange={(e) => handleStatusChange(property._id, e.target.value)}
                      className={`px-2 py-[5px] font-sans font-semibold text-center rounded-2xl text-[14px] border cursor-pointer
      ${getStatusColor(statusMap[property._id] || "Active")}
      hover:bg-opacity-80 duration-200`}
                    >
                      {getStatusOptions(property.type).map((option) => (
                        <option className="bg-white text-black" key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </td>
                  {!isRequirementPath && (
                    <td className="px-3 py-2.5 group-hover:bg-white/50 relative">
                      <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                      <div className="font-sans font-semibold text-[14px] text-slate-600 max-w-[450px]">
                        {property.address}
                      </div>
                    </td>
                  )}


                  <td className="px-3 py-2.5 group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>

                    <div className="text-[14px] font-sans font-semibold text-slate-600 max-w-[490px]">
                      {showDescMap[property._id]
                        ? property.description
                        : property.description?.slice(0, 120)}

                      {property.description?.length > 120 && (
                        <span
                          className="text-blue-600 cursor-pointer hover:underline text-sm ml-1"
                          onClick={() => toggleDescription(property._id)}
                        >
                          {showDescMap[property._id] ? "Show Less" : "Show More"}
                        </span>
                      )}
                    </div>
                  </td>


                  <td className={`${pinnedColumns.includes('contact') ? 'sticky right-0' : ''} px-3 py-2.5 whitespace-nowrap bg-slate-50/95 backdrop-blur-sm  group-hover:bg-white/50 relative`}>
                    <div className="absolute left-0 inset-y-0  w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    {!contactInfoMap[property._id] ? (
                      <button
                        onClick={() => handleGetContact(property._id)}
                        className="bg-[#EFE9FF] text-[#503691] border border-[#503691] font-bold  px-4 py-2 rounded-full text-[14px]   flex items-center gap-1"
                        disabled={loadingMap[property._id]}
                      >
                        <Phone className="w-3 h-3 font-bold" />
                        <p className="">{loadingMap[property._id] ? "Loading..." : "Get Contact"}</p>
                      </button>
                    ) : (
                      <div className="flex flex-col items-start py-1 gap-1 px-2 rounded-lg bg-white text-slate-700">
                        {/* Contact Name and Number */}
                        <div className="flex items-center gap-2">
                          <p className="text-[14px] font-medium">
                            {contactInfoMap[property._id]?.name || "NA"}
                          </p>
                          {contactInfoMap[property._id]?.number && (
                            <a
                              href={`tel:${contactInfoMap[property._id].number}`}
                              className="text-blue-600 hover:underline"
                            >
                              {contactInfoMap[property._id].number}
                            </a>
                          )}
                        </div>

                        {/* Icons for Phone and WhatsApp */}
                        <div className="flex gap-3 mt-1">
                          {contactInfoMap[property._id]?.number && (
                            <>
                              <a
                                href={`tel:${contactInfoMap[property._id].number}`}
                                className="hover:scale-110 transition-transform p-1 rounded-full hover:bg-green-100"
                                title="Call"
                              >
                                <Phone className="w-4 h-4 text-green-600" />
                              </a>
                              <a
                                href={`https://wa.me/${(contactInfoMap[property._id].number || "")
                                  .replace("+91", "")
                                  .replace(/\s/g, "")   // removes spaces
                                  .trim()
                                  }?text=${encodeURIComponent(getWhatsAppMessage(property))}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:scale-110 transition-transform p-1 rounded-full hover:bg-green-100"
                                title="WhatsApp"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 448 512"
                                  className="h-4 w-4"
                                  fill="#25D366"
                                >
                                  <path d="M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z" />
                                </svg>
                              </a>

                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </td>
                  <td className="px-3 py-2.5 text-center whitespace-nowrap group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    <div className="flex flex-col items-center">
                      <span className="font-sans text-[14px] font-semibold text-slate-700">
                        {property.dailyContact || 0} people
                      </span>
                      <span className="text-[12px] text-slate-500">
                        contacted this property today
                      </span>
                    </div>
                  </td>
                  <td className={`${pinnedColumns.includes('actions') ? 'sticky right-0' : ''} px-3 py-2.5 whitespace-nowrap bg-slate-100/95 backdrop-blur-sm group-hover:bg-white/50 relative`}>
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    <div className="flex items-center gap-1.5">
                      <button
                        className="p-1.5 hover:bg-slate-200/50 rounded-lg bg-slate-100/80"
                        onClick={() => handleShareClick(property)}
                      >
                        <FaShareAlt className="w-3 h-3 text-slate-600" />
                      </button>
                      <div
                        className={`flex flex-row items-center gap-2 h-fit ${savedPropertiesMap[property._id]
                          ? " text-[#503691]"
                          : ""
                          }  px-3 py-1.5  cursor-pointer`}
                        onClick={() => handleSaveClick(property._id)}
                      >
                        {savedPropertiesMap[property._id] ? (
                          <FaBookmark className="h-4 w-4" />
                        ) : (
                          <FaRegBookmark className="h-4 w-4" />
                        )}
                      </div>

                      {!isRequirementPath && (
                        property?.images?.length > 0 || (isSpecialPath && property?.media?.length > 0) ? (
                          <Photos_Video
                            images={
                              isSpecialPath
                                ? property?.media?.map(item => item.url) || []
                                : property.images?.length > 0
                                  ? property.images[0]?.includes(",")
                                    ? property.images[0].split(",")
                                    : property.images
                                  : []
                            }
                            iconOnly={true}
                          />
                        ) : (
                          <button
                            className="p-1.5 hover:bg-slate-200/50 rounded-lg bg-slate-100/80"
                            onClick={() => toast.info("No images available for this property")}
                          >
                            <FaCameraRetro className="w-3 h-3 text-gray-400" />
                          </button>
                        )
                      )}

                    </div>
                    {/* {savedPropertiesMap[property._id] ? "Unsave" : "Save"} */}

                    {/* this is remark */}
                  </td>
                  <td className="px-3 py-2.5 max-w-full group-hover:bg-white/50 relative">
                    <div className="absolute left-0 inset-y-0 w-px bg-slate-100/50 group-hover:bg-slate-200/50 transition-colors"></div>
                    <div className="text-[14px] text-slate-600 gap-2 ">
                      {editingMap[property._id] ? (
                        <div className="flex items-center gap-2">
                          <input
                            type="text"
                            value={remarksMap[property._id] || ""}
                            onChange={(e) =>
                              setRemarksMap((prev) => ({
                                ...prev,
                                [property._id]: e.target.value,
                              }))
                            }
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                handleSaveRemark(property._id);
                              }
                            }}
                            className="border p-2 rounded w-full"
                          />
                          <AiOutlineCheck
                            className="text-green-500 cursor-pointer"
                            onClick={() => handleSaveRemark(property._id)}
                          />
                          <AiOutlineClose
                            className="text-red-500 cursor-pointer"
                            onClick={() => handleCancelEdit(property._id)}
                          />
                        </div>
                      ) : (
                        <div className="flex items-center justify-between gap-2 max-w-[400px]">
                          <p className="line-clamp-2 break-words text-sm">
                            {remarksMap[property._id] || "Add a remark"}
                          </p>
                          <button
                            className="text-blue-500 hover:underline"
                            onClick={() =>
                              setEditingMap((prev) => ({
                                ...prev,
                                [property._id]: true,
                              }))
                            }
                          >
                            Edit
                          </button>
                        </div>
                      )}
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ShareModal
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
          shareText={currentShareText}
        />
      </div>
    </div>
  );
}

export default List;

